import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { deprecatedBreakpoints } from "@jti/ui/hooks/useCurrentBreakpoint";
import "./ResponsiveImage.scss";
const ResponsiveImage = ({ alt = "", largeSrc, mediumSrc, smallSrc, onImageLoaded }) => {
    const [isLoading, setIsLoading] = useState(true);
    const handleImageLoaded = () => {
        setIsLoading(false);
        if (onImageLoaded) {
            onImageLoaded();
        }
    };
    return (_jsx("div", { className: `responsive-image__container ${isLoading ? "loading" : ""}`, children: _jsxs("picture", { children: [smallSrc && _jsx("source", { media: deprecatedBreakpoints.small, srcSet: smallSrc }), mediumSrc && _jsx("source", { media: deprecatedBreakpoints.medium, srcSet: mediumSrc }), _jsx("img", { className: "responsive-image", src: largeSrc, alt: alt, loading: "lazy", onLoad: handleImageLoaded })] }) }));
};
export default ResponsiveImage;
//# sourceMappingURL=ResponsiveImage.js.map